import Dashboard from './../components/users/Dashboard.vue'
import Show from './../components/users/Show.vue'
import Create from './../components/users/Create.vue'
import Edit from './../components/users/Edit.vue'
import Root from './../components/Root.vue'
export default {
  path: 'users',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.users.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.users.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.users.create',
      component: Create
    },
    {
      path: ':id/update',
      name: 'admin.users.edit',
      component: Edit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/users.js